module.exports = __webpack_public_path__ + "static/media/BenMurphy.921a7548.jpg";